export const AppRoutes: Record<string, string> = {
  home: '',
  live: 'desktop-sportsbook-live',
  prematch: 'desktop-sportsbook-prematch',
  virtualSports: 'virtual-sport',
  eLive: 'e-live',
  ePrematch: 'e-prematch',
  casinoGames: 'casino',
  casinoTournaments: 'tournaments',
  racing: 'racing'
};

export const ReservedRoutes: Record<string, string> = {
  addToBetslip: '/add-to-betslip',
  deposit: '/account/deposit'
};
